/* eslint-disable*/
import React, { useEffect, useState } from 'react';
import Arrow from 'src/assets/arrow-left.svg';

import { useTranslation } from 'react-i18next';

import {
  MenuWrapper,
  Background,
  DropdownWrapper,
  Menu,
  MenuTop,
  BackWrapper,
  BackAnchor,
  ArrowBack,
  PageTitle,
} from './styles';
import { NotificationsTable } from 'src/components';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useActions } from 'src/hooks/useActions';
import { RegularButton } from 'pg-ui-library';
import NotificationsService from 'src/services/notifications.service';

const Notifications: React.FC<{ open: boolean }> = ({ open }) => {
  const [display, setDisplay] = useState<boolean>(open);
  const [modalOpen, setModalOpen] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);

  const { t } = useTranslation();
  const { data } = useTypedSelector(state => state.notifications);
  const { getNotifications } = useActions();

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    setDisplay(open);
  }, [open]);

  const handleClearAll = async () => {
    setLoading(true);
    try {
      await NotificationsService.clearAllNotifications();
      getNotifications();
    } catch (error) {
      console.error('Failed to clear notifications', error);
    }
    setLoading(false);
  };

  const handleDistributionModalClose = () => {
    setModalOpen(false);
  };

  return (
    <MenuWrapper hide={display}>
      <Menu>
        <MenuTop>
          <BackWrapper>
            <BackAnchor onClick={() => setDisplay(false)}>
              <ArrowBack src={Arrow} />
            </BackAnchor>
            <PageTitle>{t('notifications.pageTitle')}</PageTitle>
          </BackWrapper>
          <RegularButton onClick={handleClearAll} disabled={loading}>
            {loading ? 'Clearing...' : 'Clear All Notifications'}
          </RegularButton>
        </MenuTop>
        <DropdownWrapper>
          <NotificationsTable tableData={data.notifications} />
        </DropdownWrapper>
      </Menu>
      <Background onClick={() => setDisplay(false)} />
    </MenuWrapper>
  );
};

export default Notifications;
